$(document).on('click', '[data-itemlist-usecase-nav]', function() {
  $(this).toggleClass('is-active');
});

$(document).on('focus', '.slider-val__input', function() {
  $(this).select();
});

$(document).on('change', '[data-itemlist-tree-filter] input', function() {
  if ($(this).closest('.autocomplete__choice-children').closest('label')
    .find('input')
    .first().length === 0) {
    $(this).closest('.autocomplete__choice-label').closest('label')
      .find('input')
      .each((idx, input) => {
        if ($(this)[0].id !== input.id) input.checked = false;
      });
  } else {
    $(this).closest('.autocomplete__choice-children').closest('label')
      .find('input')
      .first()
      .prop('checked', false);
  }
});
